import { Col, Row, Image, } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TableComp from "../component/Table";
import { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import ReactLoading from "react-loading";
import SessionUtil from "../util/SessionUtil";
import NavLink from "../component/NavLink";
import TimeLine from "../component/Timeline";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // مهم جداً
const CustomRow = ({
  rowData,
  columnNames,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <tr>
      {columnNames.map((columnName, index) => (
        <td key={index}>
          {columnName === "itemsNo" ? (
            <span>#{rowData.ItemId}</span>
          ) : columnName === "PriceWithProfit" ? (
            rowData.ItemPriceWithProfit === null ? (
              "---"
            ) : (
              "$ " + rowData.ItemPriceWithProfit
            )
          ) : columnName === "itemPrice" ? (
            "$ " + rowData?.ItemPrice ? (
              "$ " + rowData.ItemPrice
            ) : (
              "---"
            )
          ) : columnName === "Image" ? (
            rowData?.ItemImage ? (
              <div className="dimension-40">
                <Image
                  alt="image"
                  src={rowData.ItemImage}
                  className="img-fluid cursor-pointer"
                  onClick={() => setIsOpen(true)}
                />
                {isOpen && (
                  <Lightbox
                    mainSrc={rowData.ItemImage}
                    onCloseRequest={() => setIsOpen(false)}
                  />
                )}
              </div>
            ) : (
              <div className="img-empty"></div>
            )
          ) : (
            <p className="mb-0">
              {rowData?.[columnName] ? rowData[columnName] : "---"}
            </p>
          )}
        </td>
      ))}
    </tr>
  );
};

const OrderItems = () => {
  const { t } = useTranslation();
  const lang = sessionStorage.getItem("lang");
  const navigate = useNavigate();
  const location = useLocation();
  const [timeLine, setTimeLine] = useState({});
  const { state } = location;
  const columnNames = [
    "itemsNo",
    "Image",
    "ItemNameEn",
    "ItemNameAr",
    "itemPrice",
    "PriceWithProfit",
  ];
  const [sortedData, setSortedData] = useState([]);
  const [loading, setLoading] = useState(true);
  const isLoggedIn = SessionUtil.isLoggedIn(); // Custom hook or context
  const getApi = useCallback(async () => {
    const res = await ApiUtil.getApi(
      state.type === "store"
        ? ApiPath.GET_ORDER_BY_ID + "?Id=" + state.orderData.OrderId
        : ApiPath.GET_DRIVER_ORDER_BY_ID + "?Id=" + state.orderData.OrderId,
      "GET"
    );
    if (res.IsSuccessfull) {
      setSortedData(res.Result.OrderDetails);
      setLoading(false);
      setTimeLine(res.Result);
    }
  }, [state]);
  useEffect(() => {
    if (isLoggedIn) {
      getApi();
    }
  }, [getApi, isLoggedIn]);

  const handleNav = () => {
    navigate(`/Orders/${state.type}/${state.orderData.EntityId}`, {
      state: {
        type: state.type,
        id: state.orderData.EntityId,
        data: state.data,
      },
    });
  };
  return (
    <Row className="g-0 justify-content-center">
      {!loading ? (
        <>
          <Col lg={8} className="position-relative">
            <div className=" mt-4 d-flex justify-content-between gap-2">
              <div className="flex-gap-2">
                {/* <Nav.Link
                  onClick={handleNav}
                  href={`/Orders/${state.type}/${state.orderData.EntityId}`}
                >
                  {lang === "ar" ? (
                    <IoMdArrowRoundForward size={20} />
                  ) : (
                    <IoMdArrowRoundBack size={20} />
                  )}
                </Nav.Link> */}
                <p className="title mb-0">{t("Order Items")} </p>
              </div>
            </div>
            <TableComp
              data={sortedData}
              columnNames={columnNames}
              setSortedData={setSortedData}
              page="item"
              withoutAction={true}
            >
              {sortedData.map((rowData, index) => (
                <CustomRow
                  key={index}
                  rowData={rowData}
                  columnNames={columnNames}
                />
              ))}
            </TableComp>
          </Col>

          <Col md={1}>
            <div className="divider-vertical mx-auto"></div>
          </Col>
          <Col lg={3} className="mt-5">
            <NavLink />
            <TimeLine data={timeLine} page="itemOrder" type="itemOrder" />
          </Col>
        </>
      ) : (
        <Col lg={12} className="loading-style">
          <ReactLoading
            type={"bars"}
            color={"#c8c8c8"}
            height={"50px"}
            width={"50px"}
          />
        </Col>
      )}
    </Row>
  );
};

export default OrderItems;
